(function () {

  'use strict';

  function pxSiteDelete($filter, $http, toastr, PrinterListService) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/sites/siteDelete/siteDelete.template.html',
      link: function (scope) {

        scope.confirm = {
          delete: false
        };

        scope.gettingData = false;

        scope.delete = function () {
          switch (scope.context.type) {
            case 'file':
            case 'folder':
              deleteSite();
              break;
            case 'NETWORK':
              deletePrinter();
              break;
          }
        };

        (function () {
          getDescendants();
        })();

        function getDescendants() {
          if (scope.context.type === 'folder') {
            scope.gettingData = true;
            $http.get(scope.context.links['px:descendants'].href)
              .then(function (response) {
                scope.foldersNames = '';
                scope.sitesNames = '';
                if (response.data._embedded) {
                  angular.forEach(response.data._embedded['px:siteResources'], function (site) {
                    if (site.type === 'COLLECTION') {
                      scope.foldersNames = scope.foldersNames + site.name + ', ';
                    } else {
                      scope.sitesNames = scope.sitesNames + site.name + ', ';
                    }
                  });
                }
                scope.foldersNames = scope.foldersNames.substring(0, scope.foldersNames.length - 2);
                scope.sitesNames = scope.sitesNames.substring(0, scope.sitesNames.length - 2);
                scope.gettingData = false;
              })
              .catch(function () {
                scope.gettingData = false;
              });
          }
        }

        function deletePrinter() {
          const printer = {
            info: scope.context
          };
          PrinterListService.deletePrinter(printer)
            .then(function (response) {
              toastr.success($filter('translate')('ChangesSaved'));
            })
            .catch(function () {
              toastr.error($filter('translate')('ERROR'));
            });
          scope.callback();
        }

        function deleteSite() {
          scope.context.deleteSite()
            .then(function (response) {
              toastr.success($filter('translate')('ChangesSaved'));
            })
            .catch(function (response) {
              let errorMessage;
              if (response.status === 409 && response.data?.errorCode === 'SITE_REFERENCED') {
                const siteName = response.data.parameters[0];
                const cloudStorageNames = response.data.parameters[1].split(':').join(', ');
                if (scope.context.type === 'folder') {
                  errorMessage = $filter('stringular')($filter('translate')('CannotDeleteFolderReferencedByCloudStorage'), siteName, cloudStorageNames);
                } else if (scope.context.type === 'file') {
                  errorMessage = $filter('stringular')($filter('translate')('CannotDeleteSiteReferencedByCloudStorage'), siteName, cloudStorageNames);
                } else {
                  errorMessage = $filter('translate')('ERROR');
                }
              } else {
                errorMessage = $filter('translate')('ERROR');
              }
              toastr.error(errorMessage);
            });
          scope.callback();
        }

      }
    };
  }

  pxSiteDelete.$inject = ['$filter', '$http', 'toastr', 'PrinterListService'];

  angular
    .module('printix-admin')
    .directive('pxSiteDelete', pxSiteDelete);

})();
